import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-centers-center-online-show-card',
  templateUrl: './centers-center-online-show-card.component.html',
  styleUrls: ['./centers-center-online-show-card.component.scss']
})
export class CentersCenterOnlineShowCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() center;
  basicDataForm = new FormGroup({
    online: new FormControl(null)
  });
  updateShowOnlineSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
    private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.center && this.center.Online) {
      this.resetForm();
    }
  }

  public inputChange() {
    this.submitForm();
  }

  public submitForm() {
    this.updateShowOnlineSubscription = this.centersCentersService.updateShowOnline(this.center.InternalId, this.basicDataForm.get('online').value).pipe(
      tap(o => this.snackbarService.open(o['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      online: this.center.Online
    });
  }

  ngOnDestroy() {
    if (this.updateShowOnlineSubscription) { this.updateShowOnlineSubscription.unsubscribe(); }
  }
}
